import { api_without_cancellation } from "../api/api";

export const checkPendingCost = async ({
  case_id,
  client_id,
  source_object,
  source_object_id,
  source_key,
}) => {
  try {
    const response = await api_without_cancellation.post("/api/cost-requests/pending/", {
      case_id,
      client_id,
      source_object,
      source_object_id,
      source_key,
    });

    const costObject = response?.data?.cost;
    return Boolean(costObject);
  } catch (error) {
    console.error(error);
    return false;
  }
};

export default checkPendingCost;
